// src/UserActivityProvider.js
import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';

let socket;

const UserActivityProvider = ({ children }) => {
  const [userId, setUserId] = useState(null);

  // Function to load user from localStorage
  const loadUserFromStorage = () => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user?._id) {
          setUserId(user._id);
        }
      } catch (e) {
        console.error("Failed to parse user from localStorage", e);
      }
    } else {
      setUserId(null);
    }
  };

  // Run on mount + listen for login/logout events
  useEffect(() => {
    loadUserFromStorage();

    // listen for login (custom event we dispatch after login)
    window.addEventListener('user-login', loadUserFromStorage);
    // listen for logout if you implement it
    window.addEventListener('user-logout', loadUserFromStorage);

    // still listen for cross-tab changes
    window.addEventListener('storage', loadUserFromStorage);

    return () => {
      window.removeEventListener('user-login', loadUserFromStorage);
      window.removeEventListener('user-logout', loadUserFromStorage);
      window.removeEventListener('storage', loadUserFromStorage);
    };
  }, []);

  // Connect socket when userId is available
  useEffect(() => {
    if (!userId) return;

    socket = io(process.env.REACT_APP_SERVER_URL || 'http://localhost:8000', {
      query: { userId },
      transports: ['websocket', 'polling'], // prefer websocket for reliability
    });

    const sendActivity = () => {
      if (socket?.connected) {
        socket.emit('user-activity', { userId });
      }
    };

    // user activity events
    window.addEventListener('mousemove', sendActivity);
    window.addEventListener('keypress', sendActivity);
    window.addEventListener('click', sendActivity);
    window.addEventListener('scroll', sendActivity);
    window.addEventListener('touchstart', sendActivity);

    socket.on('connect', () => {
      console.log(`✅ Socket connected for user: ${userId}`);
      // Immediately signal activity so the inactivity timer starts fresh
      sendActivity();
    });

    socket.on('disconnect', () => {
      console.log(`❌ Socket disconnected for user: ${userId}`);
    });

    return () => {
      window.removeEventListener('mousemove', sendActivity);
      window.removeEventListener('keypress', sendActivity);
      window.removeEventListener('click', sendActivity);
      window.removeEventListener('scroll', sendActivity);
      window.removeEventListener('touchstart', sendActivity);
      socket.disconnect();
    };

  }, [userId]);

  return <>{children}</>;
};

export default UserActivityProvider;
